import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcLogHandler } from './rpc-log-handler';
import { RpcLogKey, RpcLogRecord } from './rpc-log-model';

/**
 * RpcLog subject interface.
 */
export interface RpcLogSubject extends Subject<DeferredData<RpcLogRecord, void>> {}

/**
 * The class to implement RpcLog with Subject server.
 */
export class RpcLogSubjectServer extends RpcSubjectServer<RpcLogRecord, void> implements RpcLogHandler {
    /**
     * Initializes a new instance of the RpcLogSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcLogKey.command);
    }

    /**
     * The handler to respond a request for RpcLog call.
     *
     * @param data The RPC log record object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcLogRecord): Promise<void> {
        return this.processNextForSubject(RpcLogKey.command, data);
    }
}
